export default __webpack_public_path__ + "static/601-25e9a89eb2091bfc1011327ef694dd7e.gif";